// src/customerlogins/components/CustomerFooter.jsx
import React from 'react';

function CustomerFooter() {
  return (
    <footer className="bg-light text-center text-muted py-2 mt-auto">
      <small>&copy; {new Date().getFullYear()} Visitor Management System</small>
    </footer>
  );
}

export default CustomerFooter;
